import { Search, X } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { ArrowUpDown } from 'lucide-react';

interface StudentFiltersProps {
  status: string;
  sortBy: string;
  sortOrder: string;
  searchDraft: string;
  onStatusChange: (value: string | null) => void;
  onSortByChange: (value: string | null) => void;
  onSortOrderToggle: () => void;
  onSearchChange: (value: string) => void;
  onSearchClear: () => void;
}

export function StudentFilters({
  status,
  sortBy,
  sortOrder,
  searchDraft,
  onStatusChange,
  onSortByChange,
  onSortOrderToggle,
  onSearchChange,
  onSearchClear,
}: StudentFiltersProps) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="relative w-64">
        <Search className="pointer-events-none absolute left-2 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          value={searchDraft}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search name, email, telegram…"
          className="h-9 pl-8 pr-8"
        />
        {searchDraft !== '' && (
          <button
            type="button"
            onClick={onSearchClear}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
            aria-label="Clear search"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        )}
      </div>

      <Select value={status} onValueChange={onStatusChange}>
        <SelectTrigger className="w-[140px]">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All</SelectItem>
          <SelectItem value="active">Active</SelectItem>
          <SelectItem value="inactive">Inactive</SelectItem>
        </SelectContent>
      </Select>

      <Select value={sortBy} onValueChange={onSortByChange}>
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Sort by" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="name">Name</SelectItem>
          <SelectItem value="joined_at">Joined</SelectItem>
          <SelectItem value="completion_rate">Completion Rate</SelectItem>
          <SelectItem value="streak">Streak</SelectItem>
        </SelectContent>
      </Select>

      <Button variant="outline" size="icon" onClick={onSortOrderToggle}>
        <ArrowUpDown className="h-4 w-4" />
        <span className="sr-only">{sortOrder === 'asc' ? 'Ascending' : 'Descending'}</span>
      </Button>
    </div>
  );
}
